const { REACT_APP_PROXY_HOST } = process.env;
const ENDPOINT_COCKPIT_OPERATIONNEL = (REACT_APP_PROXY_HOST || '') + '/monitoring/cockpit/operationnel';
const ENDPOINT_COCKPIT_INCIDENTS = (REACT_APP_PROXY_HOST || '') + '/monitoring/cockpit/incidents';

export async function chargerCockpitOperationnel(filtres = {}) {
  const params = new URLSearchParams();
  if (filtres.journee) params.set('journee', filtres.journee);

  const query = params.toString();
  const url = query ? `${ENDPOINT_COCKPIT_OPERATIONNEL}?${query}` : ENDPOINT_COCKPIT_OPERATIONNEL;

  // DEBUG navigation
  console.log(`[cockpitOperationnelApi] fetch → ${url} | journee envoyée: ${filtres.journee || '(aucune)'}`);

  const reponse = await fetch(url, { method: 'GET' });
  const texte = await reponse.text();
  if (!reponse.ok) {
    throw new Error(`HTTP ${reponse.status} — ${url}`);
  }
  const payload = JSON.parse(texte);

  // DEBUG navigation
  const incidents = payload.incidentsCritiques || payload.incidents || [];
  const tsMax = incidents.length ? (incidents[0].ts_event || incidents[0].recu_at || 'n/d') : 'n/d';
  const tsMin = incidents.length ? (incidents[incidents.length - 1].ts_event || incidents[incidents.length - 1].recu_at || 'n/d') : 'n/d';
  console.log(`[cockpitOperationnelApi] réponse ← ${incidents.length} incidents | ts_min: ${tsMin} | ts_max: ${tsMax}`);

  return payload;
}

export async function chargerIncidentsOperationnels(filtres = {}) {
  const params = new URLSearchParams();
  if (filtres.camera) params.set('camera', filtres.camera);
  if (filtres.severite && filtres.severite !== 'toutes') params.set('severite', filtres.severite);
  if (filtres.type && filtres.type !== 'tous') params.set('type', filtres.type);

  const query = params.toString();
  const url = query ? `${ENDPOINT_COCKPIT_INCIDENTS}?${query}` : ENDPOINT_COCKPIT_INCIDENTS;
  const reponse = await fetch(url, { method: 'GET' });
  const texte = await reponse.text();
  if (!reponse.ok) {
    throw new Error(`HTTP ${reponse.status} â€” ${url}`);
  }
  const payload = JSON.parse(texte);
  return Array.isArray(payload.incidents) ? payload.incidents : [];
}



// WEBPACK FOOTER //
// src/components/cockpit/cockpitOperationnelApi.js